import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { replacementServicePath } from '@/lib/replacementFlow';

/**
 * Shown when a provider cancelled after customer payment and a payment entitlement exists.
 */
export default function ReplacementProviderBanner({ booking }) {
  const entitlement = booking?.replacement_entitlement;
  if (!entitlement?.available || !entitlement.source_booking_id) {
    return null;
  }

  const serviceKey = booking.service_key;
  const replacementId = entitlement.source_booking_id;
  const targetPath = replacementServicePath(serviceKey, replacementId);
  if (!targetPath) return null;

  return (
    <div
      className="resqly-card p-4 space-y-3 bg-amber-50 border border-amber-200"
      data-testid="replacement-provider-banner"
    >
      <div className="font-semibold text-slate-900">Your provider cancelled this booking</div>
      <p className="text-sm text-slate-700">
        Your payment is protected. You can search for another provider without paying again.
      </p>
      <Button
        asChild
        className="w-full bg-blue-700 hover:bg-blue-800"
        data-testid="find-another-provider-btn"
      >
        <Link to={targetPath}>Find Another Provider</Link>
      </Button>
    </div>
  );
}
